export default "__VITE_ASSET__B86Liyqy__"